// extracted by mini-css-extract-plugin
module.exports = {"pricingFeatures":"PricingFeaturesList_pricingFeatures__3G82s"};